var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-05__Icn/40px/Form-05",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-05__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Form-05__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C19.6357306,10 21.0880049,10.7854695 22.0002202,11.9998057 C26.418278,12 30,15.3578644 30,19.5 C30,23.6421356 26.418278,27 22,27 C21.6659568,27 21.3366954,26.9808061 21.0134023,26.9435306 C19.8648942,28.7792996 17.825002,30 15.5,30 C11.9101491,30 9,27.0898509 9,23.5 C9,20.5864978 10.916872,18.1207051 13.5582522,17.2949857 C13.2010793,16.6082748 13,15.8276197 13,15 C13,12.2385763 15.2385763,10 18,10 Z M18,12 C16.3431458,12 15,13.3431458 15,15 C15,15.4181845 15.0845128,15.8202406 15.2456691,16.1899984 L15.3325978,16.3721109 L16.4347825,18.4912031 L14.1549919,19.2038864 C12.2934726,19.7858142 11,21.517897 11,23.5 C11,25.9852814 13.0147186,28 15.5,28 C16.9921024,28 18.3562464,27.2697786 19.1906047,26.0752045 L19.3178842,25.8827674 L19.98777,24.8120258 L21.2424834,24.9566935 C21.4920164,24.9854645 21.7448034,25 22,25 C25.3415292,25 28,22.5076836 28,19.5 C28,16.5622924 25.4637555,14.1161566 22.2321211,14.0038347 L22.0001322,13.9998057 L21.0011504,13.9997617 L20.4011455,13.2010384 C19.8361875,12.4489693 18.9572787,12 18,12 Z",
    id: ".._.._src_svg_Icn_40px_Form-05__Combined-Shape-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm05);
export default __webpack_public_path__ + "static/media/Form-05.fe8b4cec578fe68f223a840f66f3b435.svg";
export { ForwardRef as ReactComponent };